<template>
  <div v-show="isActive">
    <slot />
  </div>
</template>

<script>
export default {
  inject: ["tabsState", "registerTab", "unregisterTab"],

  props: {
    title: {
      type: String,
      required: true,
    },
    metadata: String,
    selected: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isActive() {
      return this.tabsState && this.tabsState.activeTabTitle === this.title;
    },
  },

  created() {
    if (this.registerTab) {
      this.registerTab({
        title: this.title,
        selected: this.selected,
      });
    }
  },

  beforeUnmount() {
    if (this.unregisterTab) {
      this.unregisterTab(this.title);
    }
  },

  watch: {
    selected(newValue) {
      if (newValue && this.tabsState) {
        this.tabsState.activeTabTitle = this.title;
      }
    },
  },
};
</script>
